module.exports = __webpack_public_path__ + "pe.fda66729797431050527.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/pe.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/pe.svg
// module chunks = styles